import { addYupMethods, setYupLocale } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

addYupMethods();
setYupLocale(i18n);
